var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4351,
    cy: 10.6859,
    rx: 6.18605,
    ry: 6.18592,
    fill: "#E43F36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3317 18.3485L18.9153 24.2498L20.6229 17.8867C28.5596 21.0037 28.9347 22.3733 28.7638 27.7692L17.0932 35.0823L14.5683 29.3262L6.0928 33.0438C6.03995 32.0734 6.08724 31.1438 6.12824 30.3377C6.15139 29.8828 6.17253 29.4672 6.17253 29.1059C6.17253 28.6316 6.16986 28.1865 6.16736 27.768C6.15187 25.1814 6.14246 23.6107 6.80607 22.4128C7.65638 20.8779 9.61165 19.9552 14.0749 18.2917L15.7109 24.3883L17.3317 18.3485Z",
    fill: "#E43F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2915 32.2486L14.1948 31.8767L13.7949 30.9055L12.8552 31.3746L13.2915 32.2486ZM15.9523 38.7101L15.049 39.082L15.4863 40.1439L16.4643 39.5421L15.9523 38.7101ZM40.6597 23.506L29.3839 23.8223L35.2958 33.4293L40.6597 23.506ZM7.71938 36.1222L13.7279 33.1227L12.8552 31.3746L6.8467 34.3742L7.71938 36.1222ZM12.3882 32.6206L15.049 39.082L16.8556 38.3381L14.1948 31.8767L12.3882 32.6206ZM16.4643 39.5421L33.6838 28.9458L32.6598 27.2818L15.4403 37.8781L16.4643 39.5421Z",
    fill: "#E5813B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon-sales.a3f86acbf658307e7893d220317af19d.svg";
export { ForwardRef as ReactComponent };